/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useEffect, useMemo, useState } from 'react'
import { FrontSide, TextureLoader } from 'three';
import { useThree } from '@react-three/fiber';
import concreteImg from "../../../../assets/images/installation-surface/1.jpg"
import asphaltImg from "../../../../assets/images/installation-surface/2.jpg"
import groundImg from "../../../../assets/images/installation-surface/3.jpg"
import gravelImg from "../../../../assets/images/installation-surface/4.jpg"
import { params } from '../../../../redux/reducers/reducer'
import { extrudeSettings, textureAnisotropy } from '../../../../utils/Functions';
import { useTexture } from '@react-three/drei';

const InstallationSurface = () => {
        const { gl } = useThree();

        const cover = 2
        const borderWidth = 0.25
        const groundScaleZ = 1;
        const groundPositionY = 0.1;

        const [repeatX, setRepeatX] = useState(params.p_w)
        const [repeatY, setRepeatY] = useState(params.p_d)
        const [borderWidthLeft, setBorderWidthLeft] = useState(-params.p_w / 2)
        const [borderWidthRight, setBorderWidthRight] = useState(params.p_w / 2)
        const [borderLengthFront, setBorderLengthFront] = useState(-params.p_d / 2)
        const [borderLengthBack, setBorderLengthBack] = useState(params.p_d / 2)

        const [groundPositionX, setGroundPositionX] = useState(0)
        const [groundPositionZ, setGroundPositionZ] = useState(0)
        const [groundScaleX, setGroundScaleX] = useState(params.p_w + cover)
        const [groundScaleY, setGroundScaleY] = useState(params.p_d + cover);


        const [textures, setTextures] = useState(useTexture([process.env.REACT_APP_BASE_URL+concreteImg, process.env.REACT_APP_BASE_URL+asphaltImg, process.env.REACT_APP_BASE_URL+groundImg, process.env.REACT_APP_BASE_URL+gravelImg]));

        const texture1 = useMemo(() => {
            const tex = textures[params.p_i_s - 1].clone();
            textureAnisotropy(gl, tex, repeatX / 10 , repeatY / 10 , 0);
            return tex;
        }, [params.p_i_s, repeatX , repeatY]);

        const texture2 = useMemo(() => {
            const tex = textures[params.p_i_s - 1].clone();
            textureAnisotropy(gl, tex, 0.2 , 0.2 , 0);
            return tex;
        }, [params.p_i_s]);
        

        const groundBorderModel = useMemo(() => {
            let groundBorderGeo = new THREE.Shape();
            groundBorderGeo.moveTo(borderWidthRight + cover / 2, borderLengthBack + cover / 2);     //bottom left
            groundBorderGeo.lineTo(borderWidthLeft - cover / 2, borderLengthBack + cover / 2);      //top left
            groundBorderGeo.lineTo(borderWidthLeft - cover / 2, borderLengthFront - cover / 2);     // top right
            groundBorderGeo.lineTo(borderWidthRight + cover / 2, borderLengthFront - cover / 2);    // bottom right
            groundBorderGeo.closePath()
    
            let groundBorderHoles = new THREE.Shape();
            groundBorderHoles.moveTo(borderWidthRight + cover / 2 - borderWidth, borderLengthBack + cover / 2 - borderWidth);       //bottom left
            groundBorderHoles.lineTo(borderWidthLeft - cover / 2 + borderWidth, borderLengthBack + cover / 2 - borderWidth);        //top left
            groundBorderHoles.lineTo(borderWidthLeft - cover / 2 + borderWidth, borderLengthFront - cover / 2 + borderWidth);       // top right
            groundBorderHoles.lineTo(borderWidthRight + cover / 2 - borderWidth, borderLengthFront - cover / 2 + borderWidth);      // bottom right
            groundBorderHoles.closePath()
    
            groundBorderGeo.holes.push(groundBorderHoles)
            
            return groundBorderGeo;
        }, [borderWidthRight, borderWidthLeft, borderLengthBack, borderLengthFront])

        useMemo(() => {
            if (params.add_left_lean === true && params.add_right_lean === false) {
                setGroundScaleX(params.p_w + params.lean_p_w + cover)
                setGroundPositionX(-params.lean_p_w / 2)
                setRepeatX(params.p_w + params.lean_p_w)
                setBorderWidthLeft(-params.p_w / 2 - params.lean_p_w)    
                setBorderWidthRight(params.p_w / 2)
            } else if (params.add_left_lean === false && params.add_right_lean === true) {
                setGroundScaleX(params.p_w + params.leanR_p_w + cover)
                setGroundPositionX(params.leanR_p_w / 2)
                setRepeatX(params.p_w + params.leanR_p_w)
                setBorderWidthLeft(-params.p_w / 2)
                setBorderWidthRight(params.p_w / 2 + params.leanR_p_w)
            } else if (params.add_left_lean === true && params.add_right_lean === true) {
                setGroundScaleX(params.p_w + params.leanR_p_w + params.lean_p_w + cover)
                setGroundPositionX(-params.lean_p_w / 2 + params.leanR_p_w / 2)
                setRepeatX(params.p_w + params.leanR_p_w + params.lean_p_w)
                setBorderWidthLeft(-params.p_w / 2 - params.lean_p_w)
                setBorderWidthRight(params.p_w / 2 + params.leanR_p_w)
            } else {
                setRepeatX(params.p_w)
                setGroundScaleX(params.p_w + cover)
                setGroundPositionX(0)
                setBorderWidthLeft(-params.p_w / 2)
                setBorderWidthRight(params.p_w / 2)
            }
        
        }, [params.add_left_lean, params.add_right_lean, params.lean_p_w, params.leanR_p_w, params.p_w])
        
        useMemo(() => {
            if (params.add_front_lean === true && params.add_back_lean === false) {
                setGroundScaleY((params.p_d + params.leanF_p_w + cover))
                setGroundPositionZ(params.leanF_p_w / 2)
                setRepeatY(params.p_d + params.leanF_p_w)
                setBorderLengthFront(-params.p_d / 2 - params.leanF_p_w)
                setBorderLengthBack(params.p_d / 2)
            } else if (params.add_front_lean === false && params.add_back_lean === true) {
                setGroundScaleY(((params.p_d + params.leanB_p_w) + cover))
                setGroundPositionZ(-params.leanB_p_w/2)
                setRepeatY(params.p_d + params.leanB_p_w)
                setBorderLengthFront(-params.p_d / 2)
                setBorderLengthBack(params.p_d / 2 + params.leanB_p_w)
            } else if (params.add_front_lean === true && params.add_back_lean === true) {
                setGroundScaleY(((params.p_d + params.leanB_p_w + params.leanF_p_w) + cover))
                setGroundPositionZ(-params.leanB_p_w/2 + params.leanF_p_w / 2)
                setRepeatY(params.p_d + params.leanB_p_w + params.leanF_p_w)
                setBorderLengthFront(-params.p_d / 2 - params.leanF_p_w)
                setBorderLengthBack(params.p_d / 2 + params.leanB_p_w)
            } else {
                setRepeatY(params.p_d)
                setGroundScaleY(((params.p_d) + cover))
                setGroundPositionZ(0)
                setBorderLengthFront(-params.p_d / 2)
                setBorderLengthBack(params.p_d / 2)
            }          
        
        }, [params.add_front_lean, params.add_back_lean, params.leanF_p_w, params.leanB_p_w, params.p_d])        

        useMemo(() => {        
            if (params.isShowCenter) {
                setGroundScaleX(params.p_w + cover)
                setGroundScaleY((params.p_d + cover))
    
                setGroundPositionX(0)
                setGroundPositionZ(0)
    
                setBorderWidthLeft(-params.p_w / 2)
                setBorderWidthRight(params.p_w / 2)
                setBorderLengthFront(-params.p_d / 2)
                setBorderLengthBack(params.p_d / 2)
            }
        
        }, [params.isShowCenter])

    return (
        <>
            <mesh name="Ground-Surface"position={[groundPositionX, groundPositionY, groundPositionZ]} rotation={[Math.PI / -2, -0.0001, 0]} scale={[groundScaleX,groundScaleY,groundScaleZ]}>
                <planeGeometry />
                <meshBasicMaterial color={'#E1DED9'} map={texture1} side={FrontSide} roughness={0.5} />
            </mesh>
            <mesh name="Ground-Surface-Border" rotation={[Math.PI / -2, 0, 0]}>
                <extrudeGeometry args={[groundBorderModel, extrudeSettings(0.2)]} />
                <meshBasicMaterial color={'#DEDCD7'} map={texture2} side={FrontSide} roughness={0.5} />
            </mesh>
        </>
    )
}

export default InstallationSurface